<template>
  <div class="scan">
    <ul>
      <li><strong class="scan-tt">扫一扫</strong></li>
      <li>
        <div class="scan-ig" @click="scan"></div>
      </li>
      <li>
        <p class="description description-1">扫描指引单左上角的二维码</p>
        <p class="description">查询下一站体检信息</p>
      </li>
    </ul>
  </div>
</template>

<script>
  import api from "@/fetch/api";
  import {
    restore
  } from '../fetch/twocode';
  export default {
    data() {
      return {
        NAME: "",
        STATION: "",
        WAITING: "",
        NUMBER: "",
      }
    },

    methods: {
      scan() {
         var that = this;
        wx.scanQRCode({
          needResult: 1,
          scanType: ["qrCode"],
          success: function (res) {
            var code = res.resultStr;
			      code = restore(code);
            api.getNextStation(code).then(re => {
              if (re.result == true) {
                var ret = re.data;
                // this.NAME = ret.name; //姓名
                // this.STATION = ret.nextStation; //下一站
                // this.WAITING = ret.waitingNum; //等待人数
                // this.NUMBER = ret.number; //排队号
                that.$router.replace({path:'/user/scanResult',query:{NAME:ret.name, STATION:ret.nextStation,WAITING:ret.waitingNum, NUMBER:ret.number}});
              } else {
                Toast.fail(re.msg);
              }
            });
          
          }
        });

        // wx.scanQRCode({
        //   needResult: 1,
        //   scanType: ["qrCode"],
        //   success: function (res) {
        //     alert(res);
        //     var code = res.resultStr;
        //     api.getNextStation(code).then(re => {
        //       if (re.result == true) {
        //         var ret = re.data;
        //         // this.NAME = ret.name; //姓名
        //         // this.STATION = ret.nextStation; //下一站
        //         // this.WAITING = ret.waitingNum; //等待人数
        //         // this.NUMBER = ret.number; //排队号
        //         this.$router.push({path:'/user/scanResult',query:{NAME:ret.name, STATION: ret.nextStation,WAITING:ret.waitingNum, NUMBER: ret.number}});
        //       } else {
        //         alert(re.msg)
        //       }

        //     });
        //   },
        //   error: function () {
        //     console.log('扫一扫报错');
        //   }
        // });
      }
    },
    created: function () {
      window.scroll(0, 0);
    },
    mounted: function () {
      let params = {
        url: location.href.split('#')[0],
      };
      console.log(params)
      api.gettAccseeToken(params).then(re => {
        wx.config({
          debug: false,
          appId: re.appId,
          timestamp: re.timestamp,
          nonceStr: re.nonceStr,
          signature: re.signature,
          jsApiList: [
            'checkJsApi',
            'scanQRCode',
          ]
        });
        wx.error(function (res) {
          alert("sth wrong");
        });
        // wx.ready(function () {
        //   wx.checkJsApi({
        //     jsApiList: ['scanQRCode'],
        //     success: function (res) {

        //     }
        //   })
        // })
      })
    }
  }

</script>

<style lang="less">
  .scan>ul>li {
    text-align: center;
  }

  .scan {
    padding: 20px 0;

    .scan-tt {
      font-size: 20px;
    }

    .scan-ig {
      width: 100px;
      height: 100px;
      margin: 20px auto 30px;
      background: url("../assets/images/scan.png");
      background-size: 100%;
    }

    .description {
      margin: 0;
      text-align: center;
      color: #ff0000;
    }

    .description-1 {
      margin-bottom: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/queueSearch.vue